import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllLevels as apiForceDeleteAll } from "../../api/apiLevels";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllLevels() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllLevels, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiForceDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["levels"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllLevels, isForceDelete };
}
